module.exports = __webpack_public_path__ + "fonts/aktivgrotesk-medium-webfont.47d65e83.woff";